import { render } from "./alert.vue?vue&type=template&id=4c000e3e"
const script = {}

import "./alert.vue?vue&type=style&index=0&id=4c000e3e&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__